/** Locale count; abbreviate values ≥ 100_000 as `100K` (TC-SM-01A edge case). */
export function formatMetricCount(value: number): string {
  if (!Number.isFinite(value)) return '0'
  if (value >= 100_000) {
    const abbreviated = Math.round(value / 1000)
    return `${abbreviated.toLocaleString('en-US')}K`
  }
  return value.toLocaleString('en-US')
}

/** Currency for incentives tile — e.g. `$12.4K` per Figma. */
export function formatIncentivesUsd(value: number): string {
  if (!Number.isFinite(value) || value <= 0) return '$0'
  if (value >= 1000) {
    const thousands = value / 1000
    if (thousands >= 100) {
      return `$${Math.round(thousands).toLocaleString('en-US')}K`
    }
    const formatted = Number.isInteger(thousands)
      ? thousands.toLocaleString('en-US')
      : thousands.toLocaleString('en-US', { maximumFractionDigits: 1 })
    return `$${formatted}K`
  }
  return value.toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 0,
  })
}
